import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik } from "formik";
import { Grid, Typography, Card } from "@mui/material";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import api from "../../../components/services/api";
import withReactContent from "sweetalert2-react-content";
import Autocomplete from "@mui/material/Autocomplete";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});
export default function AddEmployee() {
  const history = useHistory();
  const EmpId = localStorage.getItem("EmpId");
  const classes = useStyles();
  const [company, setCompany] = useState('');
  const [branch, setBranch] = useState('');
  const [companyData, setCompanyData] = useState([]);
  const [branchData, setBranchData] = useState([]);
  const [companyDataFilter, setCompanyDataFilter] = useState([]);
  const [branchDataFilter, setBranchDataFilter] = useState([]);
  const getDataCompanyList = async () => {
    try {
      const res = await api.get("api/master/company");
      setCompanyData(res.data.data.filter((e) => e.Status === true));
      setCompanyDataFilter(res.data.data.filter((e) => e.Status === true));
    } catch (e) {
      console.log(e);
    }
  };
  const getDataBranchList = async () => {
    try {
      const res = await api.get("api/master/branch");
      // console.log(data);
      setBranchData(res.data.data.filter((e) => e.Status === true));
      setBranchDataFilter(res.data.data.filter((e) => e.Status === true));
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getDataCompanyList()
    getDataBranchList()
  },[])
  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          โรงงาน
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Factory
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Customer Support</Typography>
            <Typography>
              <span>&nbsp;</span> / Factory
            </Typography>
          </Grid>
        </Grid>

        <Formik
          initialValues={{
            factory_name: "",
            factory_phone: "",
            factory_fax: "",
            factory_address: "",
            FactoryCode: "",
            FactoryMAC5Code: "",
            CompanyId: "",
            BranchId: "",
          }}
          validate={(values) => {
            const errors = {};
            if (!values.factory_name || values.factory_name === "") {
              errors.factory_name = "กรุณากรอกชื่อโรงงาน";
            }
            if (!values.factory_address || values.factory_address === "") {
              errors.factory_address = "กรุณากรอกที่อยู่โรงงาน";
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              const check_names = {
                name: values.factory_name,
              };

              api
                .post("api/check/name", check_names)
                .then((res) => {
                  if (res.data.status) {
                    const data = {
                      name: values.factory_name,
                      address: values.factory_address,
                      phone: values.factory_phone,
                      fax: values.factory_fax,
                      FactoryCode: values.FactoryCode,
                      FactoryMAC5Code: values.FactoryMAC5Code,
                      status: 1,
                      createId: EmpId,
                     
                      CompanyId:company || null,
                      BranchId: branch || null
                    
                    };
                    api
                      .post("api/factory/create", data)
                      .then((respose) => {
                        const MySwal = withReactContent(Swal);
                        MySwal.fire({
                          icon: "success",
                          didOpen: () => {
                            MySwal.clickConfirm();
                          },
                        }).then(() => {
                          return MySwal.fire(
                            "สำเร็จ!",
                            "เพิ่มโรงงานสำเร็จ !",
                            "success"
                          ).then((result) => {
                            if (result.isConfirmed) {
                              history.push("/CustomerSupport/Factory");
                            }
                          });
                        });
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                  }
                  if (!res.data.status) {
                    const MySwal = withReactContent(Swal);
                    MySwal.fire({
                      icon: "error",

                      didOpen: () => {
                        MySwal.clickConfirm();
                      },
                    }).then(() => {
                      return MySwal.fire(
                        "ไม่สำเร็จ!",
                        "พบชื่อโรงงานนี้ซ้ำในระบบ กรุณาตรวจสอบอีกครั้ง ! <hr/> ชื่อโรงงาน : " +
                        res.data?.data[0].name +
                        "<br/> ที่อยู่ : " +
                        res.data?.data[0].address +
                        "<br/> เบอร์โทรศัพท์ : " +
                        res.data?.data[0].phone +
                        "<br/> แฟกซ์ : " +
                        res.data?.data[0].fax +
                        "<hr/>",
                        "error"
                      );
                    });
                  }
                })
                .catch((err) => {
                  const MySwal = withReactContent(Swal);
                  MySwal.fire({
                    icon: "error",
                    didOpen: () => {
                      MySwal.clickConfirm();
                    },
                  }).then(() => {
                    return MySwal.fire(
                      "ไม่สำเร็จ!",
                      "ไม่สามารถเชื่อมต่อกับ Server ได้ !",
                      "error"
                    );
                  });
                });

              setSubmitting(false);
            }, 400);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
              <Grid container>
                <Grid item xs={4} sm={4} md>
                  <TextField
                    name="factory_name"
                    label="ชื่อโรงงาน"
                    variant="outlined"
                    placeholder="ชื่อโรงงาน"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    style={{ width: "50%" }}
                    InputLabelProps={{ shrink: true }}
                    value={values.factory_name}
                    classes={{ root: !values.factory_name ? classes.customOutline : null }}
                    required
                  />

                  <br />
                  <TextField
                    name="FactoryCode"
                    label="รหัสโรงงาน"
                    variant="outlined"
                    placeholder="รหัสโรงงาน"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    style={{ width: "50%", marginTop: "10px", }}
                    InputLabelProps={{ shrink: true }}
                    value={values.FactoryCode}
                    classes={{ root: !values.FactoryCode ? classes.customOutline : null }}
                    required
                  />

                  <br />
                  <TextField
                    name="FactoryMAC5Code"
                    label="MAC-5 Code "
                    variant="outlined"
                    placeholder="MAC-5 Code "
                    onChange={handleChange}
                    onBlur={handleBlur}
                    style={{
                      width: "50%",
                      marginTop: "10px",
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={values.FactoryMAC5Code}
                  // classes={{ root: !values.factory_code ? classes.customOutline : null }}
                  // required
                  />

                  <br />
                  <TextField
                    label="ที่อยู่"
                    InputLabelProps={{ shrink: true }}
                    placeholder="ที่อยู่"
                    name="factory_address"
                    style={{
                      width: "50%",
                      marginTop: "10px",
                    }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.factory_address}
                    classes={{ root: !values.factory_address ? classes.customOutline : null }}
                    required
                  />

                  <br />
                  <TextField
                    label="เบอร์โทรศัพท์"
                    InputLabelProps={{ shrink: true }}
                    placeholder="เบอร์โทรศัพท์"
                    name="factory_phone"
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    style={{
                      width: "50%",
                      marginTop: "10px",
                    }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.factory_phone}
                  />
                  {errors.factory_phone &&
                    touched.factory_phone &&
                    errors.factory_phone}
                  <br />
                  <TextField
                    label="แฟ็กซ์"
                    InputLabelProps={{ shrink: true }}
                    placeholder="แฟ็กซ์"
                    name="factory_fax"
                    style={{
                      width: "50%",
                      marginTop: "10px",
                    }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.factory_fax}
                  />
                  {errors.factory_fax &&
                    touched.factory_fax &&
                    errors.factory_fax}
                  <br />
                  <FormControl sx={{ width: "50%",marginTop: "10px",  }}>
                          <InputLabel>Company</InputLabel>
                          <Select
                            name="Company"
                            label="Company"
                            value={company}
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => {
                              setCompany(e.target.value)
                              setBranch('')
                              if(e.target.value){
                                setBranchDataFilter(branchData.filter((item) => item?.CompanyId === e.target.value))
                              } else {
                                setBranchDataFilter(branchData)
                              }
                            }}
                          >
                            <MenuItem value={''}>None</MenuItem>
                            {companyData?.map((item) => {
                              return (
                                <MenuItem value={item?.CompanyId}>{item?.CompanyName}</MenuItem>
                              )
                            })}
                            
                            </Select>
                        </FormControl>
                        <br />
                        <FormControl sx={{ width: "50%", marginTop: "10px",  }}>
                          <InputLabel>Branch</InputLabel>
                          <Select
                            name="Branch"
                            label="Branch"
                            value={branch}
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => setBranch(e.target.value)}
                          >
                           <MenuItem value={''}>None</MenuItem>
                            {branchDataFilter?.map((item) => {
                              return (
                                <MenuItem value={item?.BranchId}>{item?.BranchName}</MenuItem>
                              )
                            })}
                          </Select>
                        </FormControl>
                </Grid>
              </Grid>
              <div>
                {errors.factory_name &&
                  touched.factory_name &&
                  errors.factory_name}
                <br />
                {errors.factory_address &&
                  touched.factory_address &&
                  errors.factory_address}
              </div>
              <div style={{ marginTop: 10 }}>
                <Button
                  type="button"
                  variant="outlined"
                  style={{
                    color: "#80c340",
                    borderColor: "#80c340",
                    marginRight: "10px",
                  }}
                  onClick={history.goBack}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  style={{
                    background: "#80c340",
                    borderColor: "#80c340",
                    marginRight: "10px",
                  }}
                  disabled={isSubmitting}
                >
                  {isSubmitting && <CircularProgress size={22} />}
                  {!isSubmitting && "SAVE"}
                </Button>
              </div>
            </form>
          )}
        </Formik>
      </Card>
    </div>
  );
}
